import b from 'b_';
import cx from 'classnames';
import React from 'react';

import Spin from '../spin/spin';

import PrepLessonItem from './__item/prep-lessons__item';
import Skeleton from './__skeleton/prep-lessons__skeleton';
import { PREP_LESSONS_THEME } from './constants';

import './prep-lessons.scss';

export interface Props {
    isLoading?: boolean;
    mix: string;
    shouldShowSkeletonLoader?: boolean;
    theme?: PREP_LESSONS_THEME;
}

// eslint-disable-next-line @typescript-eslint/ban-types
export class PrepLessons extends React.Component<React.PropsWithChildren<Props>, {}> {
    static Item = PrepLessonItem;
    static THEMES = PREP_LESSONS_THEME;

    render() {
        const { children, isLoading, mix, shouldShowSkeletonLoader, theme = PREP_LESSONS_THEME.DEFAULT } = this.props;

        const isSkeletonLoader = isLoading && shouldShowSkeletonLoader;

        return (
            <React.Fragment>
                <div className={cx(b('prep-lessons', { skeleton: isSkeletonLoader, theme }), mix)}>
                    {isSkeletonLoader ? <Skeleton /> : children}
                </div>
                {isLoading && !shouldShowSkeletonLoader && (
                    <div className="prep-lessons__spin_wrapper">
                        <Spin center />
                    </div>
                )}
            </React.Fragment>
        );
    }
}

export default PrepLessons;
